/**
 * Not sure this is the best way to do this, but I'm going to try it out.
 * @type {{SUCCESS: string}}
 */
export const THEME_TYPES = {
  SUCCESS: 'success',
} as const;
